import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { makeStyles } from '@material-ui/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import WarningIcon from '@material-ui/icons/Warning';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconCancel from '@material-ui/icons/Cancel';
import LayerItemText from '../LayerItemText';
import LayerOptions from '../LayerOptions';
import styles from './LayerItem.styles';

const useStyles = makeStyles(styles);

const LayerItem = ({ item, onDelete, onChangeVisibility }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const handleItemClick = () => {
    setOpen(!open);
  };
  if (!item) {
    return null;
  }
  // console.log('LayerItem', item)
  return (
    <React.Fragment>
      <ListItem key={`listItem${item.id}`} className={classes.layerItem}>
        {item.enabled ? (
          <Visibility className={classes.visibilityIcon} onClick={() => onChangeVisibility(item.id, !item.enabled)} />
        ) : (
          <VisibilityOff className={classes.visibilityIcon} onClick={() => onChangeVisibility(item.id, !item.enabled)} />
        )}
        <ListItemText
          primary={<LayerItemText layerId={item.id} layer={item} squareFootage={item.sqFt} />}
        />
        {open ? <ExpandLess onClick={handleItemClick} /> : <ExpandMore onClick={handleItemClick} />}
      </ListItem>
      <Collapse in={open} timeout="auto">
        <Grid container>
          <Grid item xs={12}>
            <LayerOptions layer={item} />
          </Grid>
          {item.layerType !== 'baseLayer' && (
            <Grid item xs={12} className={classes.deleteButtonContainer}>
              <Button variant="contained" color="default" onClick={() => setConfirm(!confirm)}>
                <DeleteIcon style={{ color: '#666' }} />
                <Typography>Delete</Typography>
              </Button>
            </Grid>
          )}
        </Grid>
      </Collapse>
      <Dialog open={confirm} aria-label="Are you sure?">
        <DialogTitle styles={{ textAlign: 'center' }}>Are you sure you want to delete this row?</DialogTitle>
        <DialogActions style={{ justifyContent: 'center' }}>
          <Button
            variant="contained"
            color="default"
            onClick={() => {
              onDelete(item.id);
              setConfirm(!open);
            }}
          >
            <DeleteIcon style={{ color: '#666' }} />
            <Typography>Delete</Typography>
          </Button>
          <Button variant="contained" color="default" onClick={() => setConfirm(!open)}>
            <IconCancel />
            <Typography>Cancel</Typography>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

LayerItem.propTypes = {
  item: PropTypes.object,
  onDelete: PropTypes.func,
  onChangeVisibility: PropTypes.func,
};

export default LayerItem;
